import { render, staticRenderFns } from "./ItemFilters.vue?vue&type=template&id=606d7430&scoped=true&"
import script from "./ItemFilters.vue?vue&type=script&lang=js&"
export * from "./ItemFilters.vue?vue&type=script&lang=js&"
import style0 from "./ItemFilters.vue?vue&type=style&index=0&id=606d7430&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606d7430",
  null
  
)

export default component.exports